import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import HandigPrivacy from '../views/projects/handig/Privacy.vue'
import ActiviteitenwegerPrivacy from '../views/projects/activiteitenweger/Privacy.vue'
import BoekiePrivacy from '../views/projects/boekie/Privacy.vue'
import OrPrivacy from '../views/projects/or/Privacy.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/work',
    name: 'Work'
    // component: Work
  },
  {
    path: '/about',
    name: 'About'
    // component: About
  },
  {
    path: '/contact',
    name: 'Contact'
    // component: Contact
  },
  {
    path: '/projects/handig/privacy',
    name: 'handig_privacy',
    component: HandigPrivacy
  },
  {
    path: '/projects/activiteitenweger/privacy',
    name: 'handig_privacy',
    component: ActiviteitenwegerPrivacy
  },
  {
    path: '/projects/boekie/privacy',
    name: 'boekie_privacy',
    component: BoekiePrivacy
  },
  {
    path: '/projects/or/privacy',
    name: 'or_privacy',
    component: OrPrivacy
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
